import React from "react";
import styles from "./style.module.css";
import * as PropTypes from "prop-types";
import PaymentItem from './PaymentItem';

const PaymentList = React.memo(({ paymentTypes, deletePaymentMethod, selectPayment, currentPayment }) => {

  return (
    <>
      <div className={styles.paymentList}>
        {
          paymentTypes?.map?.((item) => item &&
            <PaymentItem
              token={item.token}
              key={item.token}
              bankCardType={item.bankCardType}
              name={item.name}
              deletePaymentMethod={deletePaymentMethod}
              selectPayment={selectPayment}
              currentPayment={item.token === currentPayment}
            />)
        }
      </div>
    </>
  );
});

PaymentList.propTypes = {
  paymentTypes: PropTypes.array,
  deletePaymentMethod: PropTypes.func.isRequired,
  selectPayment: PropTypes.func.isRequired,
  currentPayment: PropTypes.string,
};

PaymentList.defaultProps = {
  paymentTypes: [],
  currentPayment: undefined,
};

export default PaymentList;
